import { defineComponent, ref, computed, toRef, watch } from 'vue-demi';
import { T as TimeFormat } from './TimeFormat-a7f5565b.js';
import { u as useDateMask, a as useTimeMask } from './useTimeMask-a1c090c1.js';
import './dom-53c9635b.js';
import '@vueuse/core';
import { u as useProxyModelValue } from './useProxyModelValue-e18f251e.js';
import '@onereach/styles/screens.json';
import '@onereach/styles/tailwind.config.json';
import { f as formatDate, a as formatTime } from './formatTime-3f37a00f.js';
import { openBlock, createElementBlock, normalizeClass, withModifiers, Fragment, createTextVNode, toDisplayString, resolveComponent, createElementVNode, renderList, createBlock, withCtx, createVNode, renderSlot, createCommentVNode } from 'vue';
import { s as script$8 } from './OrButton-e997c224.js';
import { s as script$9 } from './OrLabel-4abbce6e.js';
import { s as script$b } from './OrIconButton-5a508869.js';
import { s as script$a } from './OrIcon-9aff520e.js';
import { s as script$d } from './OrMenuItem-6caf8844.js';
import { s as script$c } from './OrMenu-95509740.js';

const DateTimePickerDateControl = [
// Layout
'layout-inline-row',
// Interactivity
'interactivity-click',
// Theme (focus)
'focus-visible:theme-border-inherit focus-visible:border-b-2', 'dark:focus-visible:theme-border-inherit-dark',
// Theme (selected)
'selected:theme-border-inherit selected:border-b-2', 'dark:selected:theme-border-inherit-dark'];
const DateTimePickerDateControlPlaceholder = [
// Theme
'theme-foreground-outline', 'dark:theme-foreground-outline-dark'];

var script$7 = defineComponent({
  name: 'OrDateTimePickerDateControl',
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: undefined,
      default: undefined
    },
    format: {
      type: [String, Function],
      required: true
    },
    locale: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  expose: ['root'],
  setup(props, context) {
    // Refs & Styles
    const root = ref();
    const rootStyles = computed(() => ['or-date-time-picker-date-control-v3', ...DateTimePickerDateControl]);
    const placeholderStyles = computed(() => [...DateTimePickerDateControlPlaceholder]);
    // State
    const model = useProxyModelValue(toRef(props, 'modelValue'), context.emit);
    const placeholder = useDateMask(toRef(props, 'format'), toRef(props, 'locale'));
    return {
      root,
      rootStyles,
      placeholderStyles,
      model,
      placeholder,
      formatDate
    };
  }
});

const _hoisted_1$3 = ["contenteditable", "selected", "required", "readonly", "disabled"];
const _hoisted_2$1 = ["disabled"];
function render$7(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles),
    contenteditable: !_ctx.disabled,
    selected: _ctx.selected,
    required: _ctx.required,
    readonly: _ctx.readonly,
    disabled: _ctx.disabled,
    onKeydown: _cache[0] || (_cache[0] = withModifiers(() => {}, ["prevent"]))
  }, [_ctx.model ? (openBlock(), createElementBlock(Fragment, {
    key: 0
  }, [createTextVNode(toDisplayString(_ctx.formatDate(_ctx.model, _ctx.format, _ctx.locale)), 1 /* TEXT */)], 64 /* STABLE_FRAGMENT */)) : (openBlock(), createElementBlock("span", {
    key: 1,
    class: normalizeClass(_ctx.placeholderStyles),
    disabled: _ctx.disabled
  }, toDisplayString(_ctx.placeholder), 11 /* TEXT, CLASS, PROPS */, _hoisted_2$1))], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1$3);
}

script$7.render = render$7;
script$7.__file = "src/components/or-date-time-picker-v3/partials/or-date-time-picker-date-control/OrDateTimePickerDateControl.vue";

const DateTimePickerDateSelect = [
// Layout
'layout-column',
// Spacing
'px-md', 'py-md', 'gap-sm'];
const DateTimePickerDateSelectButtonGroup = [
// Layout
'grid content-start', 'grid-cols-7',
// Box
'h-[262px]',
// Spacing
'-mx-[2px]', '-my-[2px]'];
const DateTimePickerDateSelectButtonGroupWeekdayItem = [
// Layout
'layout-row justify-center',
// Interactivity
'interactivity-default',
// Spacing
'mx-[2px]', 'my-[2px]', 'px-sm', 'py-sm',
// Typography
'typography-caption-regular',
// Theme
'theme-foreground-outline', 'dark:theme-foreground-outline-dark'];
const DateTimePickerDateSelectButtonGroupDateItem = [
// Box
'!min-w-fit',
// Spacing
'mx-[2px]', 'my-[2px]', '!px-sm', '!py-sm',
// Typography
'typography-caption-regular'];
const DateTimePickerDateSelectButtonGroupCurrentDateItem = [
// Theme
'theme-foreground-primary', 'dark:theme-foreground-primary-dark', 'theme-outline-primary outline-1', 'dark:theme-outline-primary-dark'];
const DateTimePickerDateSelectButtonGroupInRangeDateItem = [
// Spacing
'!mx-0', '!px-[10px]',
// Shape
'!rounded-0',
// Theme
'theme-background-primary-translucent-2', 'dark:theme-background-primary-translucent-2-dark'];

var script$6 = defineComponent({
  name: 'OrDateTimePickerDateSelect',
  components: {
    OrButton: script$8
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: undefined,
      default: undefined
    },
    initialValue: {
      type: Date,
      required: true
    },
    format: {
      type: [String, Function],
      required: true
    },
    locale: {
      type: String,
      required: true
    },
    dateFilter: {
      type: Function,
      default: undefined
    },
    rangeStart: {
      type: Date,
      default: undefined
    },
    rangeEnd: {
      type: Date,
      default: undefined
    }
  },
  emits: ['update:modelValue'],
  expose: ['root'],
  setup(props, context) {
    // Refs & Styles
    const root = ref();
    const rootStyles = computed(() => ['or-date-time-picker-date-select-v3', ...DateTimePickerDateSelect]);
    const buttonGroupStyles = computed(() => [...DateTimePickerDateSelectButtonGroup]);
    const buttonGroupWeekdayItemStyles = computed(() => [...DateTimePickerDateSelectButtonGroupWeekdayItem]);
    const buttonGroupDateItemStyles = computed(() => [...DateTimePickerDateSelectButtonGroupDateItem]);
    const buttonGroupCurrentDateItemStyles = computed(() => [...DateTimePickerDateSelectButtonGroupCurrentDateItem]);
    const buttonGroupInRangeDateItemStyles = computed(() => [...DateTimePickerDateSelectButtonGroupInRangeDateItem]);
    // State
    const model = useProxyModelValue(toRef(props, 'modelValue'), context.emit);
    const dayOptions = computed(() => {
      const monthStartDate = new Date(Date.UTC(props.initialValue.getUTCFullYear(), props.initialValue.getUTCMonth(), 1, props.initialValue.getUTCHours(), props.initialValue.getUTCMinutes()));
      const monthEndDate = new Date(Date.UTC(props.initialValue.getUTCFullYear(), props.initialValue.getUTCMonth() + 1, 0, props.initialValue.getUTCHours(), props.initialValue.getUTCMinutes()));
      const calendarStartDate = new Date(Date.UTC(monthStartDate.getUTCFullYear(), monthStartDate.getUTCMonth(), 1 - monthStartDate.getUTCDay(), monthStartDate.getUTCHours(), monthStartDate.getUTCMinutes()));
      const calendarEndDate = new Date(Date.UTC(monthEndDate.getUTCFullYear(), monthEndDate.getUTCMonth() + 1, 7 - monthEndDate.getUTCDay(), monthEndDate.getUTCHours(), monthEndDate.getUTCMinutes()));
      return (() => {
        let options = [],
          value = calendarStartDate;
        while (Number(value) !== Number(calendarEndDate)) {
          options = [...options, value];
          value = new Date(Date.UTC(value.getUTCFullYear(), value.getUTCMonth(), value.getUTCDate() + 1, value.getUTCHours(), value.getUTCMinutes()));
        }
        return options;
      })();
    });
    const currentDate = computed(() => {
      const value = new Date();
      value.setUTCHours(props.initialValue.getUTCHours());
      value.setUTCMinutes(props.initialValue.getUTCMinutes());
      value.setUTCSeconds(props.initialValue.getUTCSeconds());
      value.setUTCMilliseconds(props.initialValue.getUTCMilliseconds());
      return value;
    });
    // Methods
    function formatWeekday(value) {
      return value.toLocaleString(props.locale, {
        weekday: 'short',
        timeZone: 'UTC'
      });
    }
    function formatDay(value) {
      return value.toLocaleString(props.locale, {
        day: 'numeric',
        timeZone: 'UTC'
      });
    }
    return {
      root,
      rootStyles,
      buttonGroupStyles,
      buttonGroupWeekdayItemStyles,
      buttonGroupDateItemStyles,
      buttonGroupCurrentDateItemStyles,
      buttonGroupInRangeDateItemStyles,
      model,
      dayOptions,
      currentDate,
      formatWeekday,
      formatDay
    };
  }
});

function render$6(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrButton = resolveComponent("OrButton");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles)
  }, [createElementVNode("div", {
    class: normalizeClass(_ctx.buttonGroupStyles)
  }, [(openBlock(), createElementBlock(Fragment, null, renderList(7, weekday => {
    return createElementVNode("div", {
      key: weekday,
      class: normalizeClass(_ctx.buttonGroupWeekdayItemStyles)
    }, toDisplayString(_ctx.formatWeekday(_ctx.dayOptions[weekday - 1])), 3 /* TEXT, CLASS */);
  }), 64 /* STABLE_FRAGMENT */)), (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.dayOptions, value => {
    return openBlock(), createBlock(_component_OrButton, {
      key: Number(value),
      class: normalizeClass({
        [_ctx.buttonGroupDateItemStyles.join(' ')]: true,
        [_ctx.buttonGroupCurrentDateItemStyles.join(' ')]: Number(value) !== Number(_ctx.model) && Number(value) !== Number(_ctx.rangeStart) && Number(value) !== Number(_ctx.rangeEnd) && Number(value) === Number(_ctx.currentDate),
        [_ctx.buttonGroupInRangeDateItemStyles.join(' ')]: _ctx.rangeStart && Number(value) > Number(_ctx.rangeStart) && _ctx.rangeEnd && Number(value) < Number(_ctx.rangeEnd)
      }),
      variant: Number(value) === Number(_ctx.model) || _ctx.rangeStart && Number(value) === Number(_ctx.rangeStart) || _ctx.rangeEnd && Number(value) === Number(_ctx.rangeEnd) ? 'contained' : 'text',
      color: Number(value) === Number(_ctx.model) || _ctx.rangeStart && Number(value) === Number(_ctx.rangeStart) || _ctx.rangeEnd && Number(value) === Number(_ctx.rangeEnd) ? 'primary' : 'inherit',
      disabled: _ctx.dateFilter && !_ctx.dateFilter(value),
      onClick: withModifiers($event => _ctx.model = value, ["stop"])
    }, {
      default: withCtx(() => [createTextVNode(toDisplayString(_ctx.formatDay(value)), 1 /* TEXT */)]),
      _: 2 /* DYNAMIC */
    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "variant", "color", "disabled", "onClick"]);
  }), 128 /* KEYED_FRAGMENT */))], 2 /* CLASS */)], 2 /* CLASS */);
}

script$6.render = render$6;
script$6.__file = "src/components/or-date-time-picker-v3/partials/or-date-time-picker-date-select/OrDateTimePickerDateSelect.vue";

const DateTimePickerMobileControl = [
// Layout
'layout-column',
// Interactivity
'interactivity-auto',
// Spacing
'gap-xs',
// Theme
'theme-foreground-outline', 'dark:theme-foreground-outline-dark',
// Theme (selected)
'selected:theme-foreground-default', 'dark:selected:theme-foreground-default-dark'];
const DateTimePickerMobileControlContent = [
// Typography
'typography-headline-1'];

var script$5 = defineComponent({
  name: 'OrDateTimePickerMobileControl',
  components: {
    OrLabel: script$9
  },
  props: {
    label: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  expose: ['root'],
  setup() {
    // Refs & Styles
    const root = ref();
    const rootStyles = computed(() => ['or-date-time-picker-mobile-control-v3', ...DateTimePickerMobileControl]);
    const contentStyles = computed(() => [...DateTimePickerMobileControlContent]);
    return {
      root,
      rootStyles,
      contentStyles
    };
  }
});

const _hoisted_1$2 = ["selected"];
function render$5(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrLabel = resolveComponent("OrLabel");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles),
    selected: _ctx.selected
  }, [createVNode(_component_OrLabel, null, {
    default: withCtx(() => [createTextVNode(toDisplayString(_ctx.label), 1 /* TEXT */)]),
    _: 1 /* STABLE */
  }), createElementVNode("div", {
    class: normalizeClass(_ctx.contentStyles)
  }, [renderSlot(_ctx.$slots, "default")], 2 /* CLASS */)], 10 /* CLASS, PROPS */, _hoisted_1$2);
}

script$5.render = render$5;
script$5.__file = "src/components/or-date-time-picker-v3/partials/or-date-time-picker-mobile-control/OrDateTimePickerMobileControl.vue";

const DateTimePickerMonthSelect = [
// Layout
'layout-row justify-between',
// Spacing
'px-md', 'py-md', 'gap-md'];

var script$4 = defineComponent({
  name: 'OrDateTimePickerMonthSelect',
  components: {
    OrButton: script$8,
    OrIcon: script$a,
    OrIconButton: script$b,
    OrMenu: script$c,
    OrMenuItem: script$d
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: undefined,
      required: true
    },
    locale: {
      type: String,
      required: true
    },
    yearFilter: {
      type: Function,
      default: undefined
    },
    monthFilter: {
      type: Function,
      default: undefined
    }
  },
  emits: ['update:modelValue'],
  expose: ['root'],
  setup(props, context) {
    // Refs & Styles
    const root = ref();
    const rootStyles = computed(() => ['or-date-time-picker-month-select-v3', ...DateTimePickerMonthSelect]);
    const yearButton = ref();
    const yearButtonRoot = computed(() => {
      var _a;
      return (_a = yearButton.value) === null || _a === void 0 ? void 0 : _a.root;
    });
    const monthButton = ref();
    const monthButtonRoot = computed(() => {
      var _a;
      return (_a = monthButton.value) === null || _a === void 0 ? void 0 : _a.root;
    });
    const yearMenu = ref();
    const yearMenuState = computed(() => {
      var _a;
      return (_a = yearMenu.value) === null || _a === void 0 ? void 0 : _a.state;
    });
    const monthMenu = ref();
    const monthMenuState = computed(() => {
      var _a;
      return (_a = monthMenu.value) === null || _a === void 0 ? void 0 : _a.state;
    });
    // State
    const model = useProxyModelValue(toRef(props, 'modelValue'), context.emit);
    const yearOptions = computed(() => {
      return Array.from({
        length: 11
      }).map((_value, index, {
        length
      }) => {
        const value = model.value.getUTCFullYear() - Math.floor(length / 2) + index;
        return new Date(Date.UTC(value, model.value.getUTCMonth(), model.value.getUTCDate(), model.value.getUTCHours(), model.value.getUTCMinutes()));
      });
    });
    const monthOptions = computed(() => {
      return Array.from({
        length: 12
      }, (_value, index) => {
        const value = index;
        return new Date(Date.UTC(model.value.getUTCFullYear(), value, model.value.getUTCDate(), model.value.getUTCHours(), model.value.getUTCMinutes()));
      });
    });
    // Methods
    function goToNextMonth() {
      model.value = new Date(Date.UTC(model.value.getUTCFullYear(), model.value.getUTCMonth() + 1, model.value.getUTCDate(), model.value.getUTCHours(), model.value.getUTCMinutes()));
    }
    function goToPreviousMonth() {
      model.value = new Date(Date.UTC(model.value.getUTCFullYear(), model.value.getUTCMonth() - 1, model.value.getUTCDate(), model.value.getUTCHours(), model.value.getUTCMinutes()));
    }
    function formatYear(value) {
      return value.toLocaleString(props.locale, {
        year: 'numeric',
        timeZone: 'UTC'
      });
    }
    function formatMonth(value) {
      return value.toLocaleString(props.locale, {
        month: 'long',
        timeZone: 'UTC'
      });
    }
    return {
      root,
      rootStyles,
      yearButton,
      yearButtonRoot,
      monthButton,
      monthButtonRoot,
      yearMenu,
      yearMenuState,
      monthMenu,
      monthMenuState,
      model,
      yearOptions,
      monthOptions,
      goToNextMonth,
      goToPreviousMonth,
      formatYear,
      formatMonth
    };
  }
});

const _hoisted_1$1 = {
  class: /*#__PURE__*/normalizeClass(['layout-row-reverse', 'gap-md'])
};
function render$4(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrIconButton = resolveComponent("OrIconButton");
  const _component_OrIcon = resolveComponent("OrIcon");
  const _component_OrButton = resolveComponent("OrButton");
  const _component_OrMenuItem = resolveComponent("OrMenuItem");
  const _component_OrMenu = resolveComponent("OrMenu");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles)
  }, [createVNode(_component_OrIconButton, {
    icon: 'chevron_left',
    onClick: _cache[0] || (_cache[0] = withModifiers($event => _ctx.goToPreviousMonth(), ["stop"]))
  }), createElementVNode("div", _hoisted_1$1, [createVNode(_component_OrButton, {
    ref: 'yearButton',
    variant: 'link',
    color: 'inherit',
    onClick: _cache[1] || (_cache[1] = withModifiers($event => {
      _ctx.monthMenu && _ctx.monthMenu.close();
      _ctx.yearMenu && _ctx.yearMenu.toggle();
    }, ["stop"]))
  }, {
    default: withCtx(() => [createTextVNode(toDisplayString(_ctx.formatYear(_ctx.model)) + " ", 1 /* TEXT */), createVNode(_component_OrIcon, {
      icon: _ctx.yearMenuState === 'open' ? 'arrow_drop_up' : 'arrow_drop_down'
    }, null, 8 /* PROPS */, ["icon"])]),
    _: 1 /* STABLE */
  }), createVNode(_component_OrButton, {
    ref: 'monthButton',
    variant: 'link',
    color: 'inherit',
    onClick: _cache[2] || (_cache[2] = withModifiers($event => {
      _ctx.yearMenu && _ctx.yearMenu.close();
      _ctx.monthMenu && _ctx.monthMenu.toggle();
    }, ["stop"]))
  }, {
    default: withCtx(() => [createTextVNode(toDisplayString(_ctx.formatMonth(_ctx.model)) + " ", 1 /* TEXT */), createVNode(_component_OrIcon, {
      icon: _ctx.monthMenuState === 'open' ? 'arrow_drop_up' : 'arrow_drop_down'
    }, null, 8 /* PROPS */, ["icon"])]),
    _: 1 /* STABLE */
  }), createVNode(_component_OrMenu, {
    ref: 'yearMenu',
    trigger: _ctx.yearButtonRoot
  }, {
    default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.yearOptions, value => {
      return openBlock(), createBlock(_component_OrMenuItem, {
        key: Number(value),
        selected: Number(value) === Number(_ctx.model),
        disabled: _ctx.yearFilter && !_ctx.yearFilter(value),
        onClick: withModifiers($event => {
          _ctx.model = value;
          _ctx.yearMenu && _ctx.yearMenu.close();
        }, ["stop"])
      }, {
        default: withCtx(() => [createTextVNode(toDisplayString(_ctx.formatYear(value)), 1 /* TEXT */)]),
        _: 2 /* DYNAMIC */
      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["selected", "disabled", "onClick"]);
    }), 128 /* KEYED_FRAGMENT */))]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["trigger"]), createVNode(_component_OrMenu, {
    ref: 'monthMenu',
    trigger: _ctx.monthButtonRoot
  }, {
    default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.monthOptions, value => {
      return openBlock(), createBlock(_component_OrMenuItem, {
        key: Number(value),
        selected: Number(value) === Number(_ctx.model),
        disabled: _ctx.monthFilter && !_ctx.monthFilter(value),
        onClick: withModifiers($event => {
          _ctx.model = value;
          _ctx.monthMenu && _ctx.monthMenu.close();
        }, ["stop"])
      }, {
        default: withCtx(() => [createTextVNode(toDisplayString(_ctx.formatMonth(value)), 1 /* TEXT */)]),
        _: 2 /* DYNAMIC */
      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["selected", "disabled", "onClick"]);
    }), 128 /* KEYED_FRAGMENT */))]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["trigger"])]), createVNode(_component_OrIconButton, {
    icon: 'chevron_right',
    onClick: _cache[3] || (_cache[3] = withModifiers($event => _ctx.goToNextMonth(), ["stop"]))
  })], 2 /* CLASS */);
}

script$4.render = render$4;
script$4.__file = "src/components/or-date-time-picker-v3/partials/or-date-time-picker-month-select/OrDateTimePickerMonthSelect.vue";

const DateTimePickerPopoverFooter = [
// Layout
'layout-row-reverse',
// Layout (children)
'children:grow',
// Spacing
'px-md md:px-sm', 'py-md md:py-sm', 'gap-md md:gap-sm',
// Theme
'theme-border-outline-variant border-t-1', 'dark:theme-border-outline-variant-dark'];

var script$3 = defineComponent({
  name: 'OrDateTimePickerPopoverFooter',
  components: {
    OrButton: script$8
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['apply', 'reset'],
  expose: ['root'],
  setup() {
    // Refs & Styles
    const root = ref();
    const rootStyles = computed(() => ['or-date-time-picker-popover-footer-v3', ...DateTimePickerPopoverFooter]);
    return {
      root,
      rootStyles
    };
  }
});

function render$3(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrButton = resolveComponent("OrButton");
  return openBlock(), createElementBlock("footer", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles)
  }, [createVNode(_component_OrButton, {
    variant: 'outlined',
    disabled: _ctx.disabled,
    onClick: _cache[0] || (_cache[0] = withModifiers($event => _ctx.$emit('apply'), ["stop"]))
  }, {
    default: withCtx(() => [createTextVNode(" Done ")]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["disabled"]), createVNode(_component_OrButton, {
    variant: 'text',
    onClick: _cache[1] || (_cache[1] = withModifiers($event => _ctx.$emit('reset'), ["stop"]))
  }, {
    default: withCtx(() => [createTextVNode(" Cancel ")]),
    _: 1 /* STABLE */
  })], 2 /* CLASS */);
}

script$3.render = render$3;
script$3.__file = "src/components/or-date-time-picker-v3/partials/or-date-time-picker-popover-footer/OrDateTimePickerPopoverFooter.vue";

const DateTimePickerPopoverHeader = [
// Layout
'layout-row md:hidden',
// Spacing
'px-md', 'py-md', 'gap-xl'];

var script$2 = defineComponent({
  name: 'OrDateTimePickerPopoverHeader',
  expose: ['root'],
  setup() {
    // Refs & Styles
    const root = ref();
    const rootStyles = computed(() => ['or-date-time-picker-popover-header-v3', ...DateTimePickerPopoverHeader]);
    return {
      root,
      rootStyles
    };
  }
});

function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("header", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles)
  }, [renderSlot(_ctx.$slots, "default")], 2 /* CLASS */);
}

script$2.render = render$2;
script$2.__file = "src/components/or-date-time-picker-v3/partials/or-date-time-picker-popover-header/OrDateTimePickerPopoverHeader.vue";

const DateTimePickerTimeControl = [
// Layout
'layout-inline-row',
// Interactivity
'interactivity-click',
// Theme (focus)
'focus-visible:theme-border-inherit focus-visible:border-b-2', 'dark:focus-visible:theme-border-inherit-dark',
// Theme (selected)
'selected:theme-border-inherit selected:border-b-2', 'dark:selected:theme-border-inherit-dark'];
const DateTimePickerTimeControlPlaceholder = [
// Theme
'theme-foreground-outline', 'dark:theme-foreground-outline-dark'];

var script$1 = defineComponent({
  name: 'OrDateTimePickerTimeControl',
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: undefined,
      default: undefined
    },
    format: {
      type: [String, Function],
      required: true
    },
    locale: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  expose: ['root'],
  setup(props, context) {
    // Refs & Styles
    const root = ref();
    const rootStyles = computed(() => ['or-date-time-picker-time-control-v3', ...DateTimePickerTimeControl]);
    const placeholderStyles = computed(() => [...DateTimePickerTimeControlPlaceholder]);
    // State
    const model = useProxyModelValue(toRef(props, 'modelValue'), context.emit);
    const placeholder = useTimeMask(toRef(props, 'format'), toRef(props, 'locale'));
    return {
      root,
      rootStyles,
      placeholderStyles,
      model,
      placeholder,
      formatTime
    };
  }
});

const _hoisted_1 = ["contenteditable", "selected", "required", "readonly", "disabled"];
const _hoisted_2 = ["disabled"];
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles),
    contenteditable: !_ctx.disabled,
    selected: _ctx.selected,
    required: _ctx.required,
    readonly: _ctx.readonly,
    disabled: _ctx.disabled,
    onKeydown: _cache[0] || (_cache[0] = withModifiers(() => {}, ["prevent"]))
  }, [_ctx.model ? (openBlock(), createElementBlock(Fragment, {
    key: 0
  }, [createTextVNode(toDisplayString(_ctx.formatTime(_ctx.model, _ctx.format, _ctx.locale)), 1 /* TEXT */)], 64 /* STABLE_FRAGMENT */)) : (openBlock(), createElementBlock("span", {
    key: 1,
    class: normalizeClass(_ctx.placeholderStyles),
    disabled: _ctx.disabled
  }, toDisplayString(_ctx.placeholder), 11 /* TEXT, CLASS, PROPS */, _hoisted_2))], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1);
}

script$1.render = render$1;
script$1.__file = "src/components/or-date-time-picker-v3/partials/or-date-time-picker-time-control/OrDateTimePickerTimeControl.vue";

const DateTimePickerTimeSelect = [
// Layout
'layout-row justify-center',
// Spacing
'px-md', 'py-md', 'gap-sm',
// Typography
'typography-body-2-regular',
// Theme
'theme-foreground-default', 'dark:theme-foreground-default-dark'];
const DateTimePickerTimeSelectButtonGroup = [
// Layout
'layout-column',
// Box
'h-[294px] md:h-[238px]',
// Overflow
'overflow-x-hidden', 'overflow-y-auto'];
const DateTimePickerTimeSelectButtonGroupItem = [
// Box
'!min-w-fit',
// Typography
'typography-caption-regular'];

var script = defineComponent({
  name: 'OrDateTimePickerTimeSelect',
  components: {
    OrButton: script$8
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: undefined,
      default: undefined
    },
    initialValue: {
      type: Date,
      required: true
    },
    format: {
      type: [String, Function],
      required: true
    },
    locale: {
      type: String,
      required: true
    },
    hoursFilter: {
      type: Function,
      default: undefined
    },
    minutesFilter: {
      type: Function,
      default: undefined
    }
  },
  emits: ['update:modelValue'],
  expose: ['root'],
  setup(props, context) {
    var _a;
    // Refs & Styles
    const root = ref();
    const rootStyles = computed(() => ['or-date-time-picker-time-select-v3', ...DateTimePickerTimeSelect]);
    const buttonGroupStyles = computed(() => [...DateTimePickerTimeSelectButtonGroup]);
    const buttonGroupItemStyles = computed(() => [...DateTimePickerTimeSelectButtonGroupItem]);
    // State
    const model = useProxyModelValue(toRef(props, 'modelValue'), context.emit);
    const dayPeriod = ref(((_a = model.value) !== null && _a !== void 0 ? _a : props.initialValue).getUTCHours() < 12 ? 'am' : 'pm');
    watch(dayPeriod, value => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
      switch (value) {
        case 'am':
          model.value = new Date(Date.UTC(((_a = model.value) !== null && _a !== void 0 ? _a : props.initialValue).getUTCFullYear(), ((_b = model.value) !== null && _b !== void 0 ? _b : props.initialValue).getUTCMonth(), ((_c = model.value) !== null && _c !== void 0 ? _c : props.initialValue).getUTCDate(), ((_d = model.value) !== null && _d !== void 0 ? _d : props.initialValue).getUTCHours() - 12, ((_e = model.value) !== null && _e !== void 0 ? _e : props.initialValue).getUTCMinutes()));
          break;
        case 'pm':
          model.value = new Date(Date.UTC(((_f = model.value) !== null && _f !== void 0 ? _f : props.initialValue).getUTCFullYear(), ((_g = model.value) !== null && _g !== void 0 ? _g : props.initialValue).getUTCMonth(), ((_h = model.value) !== null && _h !== void 0 ? _h : props.initialValue).getUTCDate(), ((_j = model.value) !== null && _j !== void 0 ? _j : props.initialValue).getUTCHours() + 12, ((_k = model.value) !== null && _k !== void 0 ? _k : props.initialValue).getUTCMinutes()));
          break;
      }
    });
    const proxyTimeFormat = computed(() => {
      if (typeof props.format === 'function' || props.format === TimeFormat.Auto) {
        const timeSample = new Date(1970, 0);
        if (timeSample.toLocaleTimeString(props.locale).includes('12')) {
          return TimeFormat.H12;
        }
        return TimeFormat.H23;
      }
      return props.format;
    });
    const hoursOptions = computed(() => {
      return Array.from({
        length: 24
      }, (_value, index) => {
        var _a, _b, _c, _d;
        const value = index;
        return new Date(Date.UTC(((_a = model.value) !== null && _a !== void 0 ? _a : props.initialValue).getUTCFullYear(), ((_b = model.value) !== null && _b !== void 0 ? _b : props.initialValue).getUTCMonth(), ((_c = model.value) !== null && _c !== void 0 ? _c : props.initialValue).getUTCDate(), value, ((_d = model.value) !== null && _d !== void 0 ? _d : props.initialValue).getUTCMinutes()));
      }).filter(value => {
        if (proxyTimeFormat.value === TimeFormat.H23) {
          return true;
        }
        switch (dayPeriod.value) {
          case 'am':
            return value.getUTCHours() < 12;
          case 'pm':
            return value.getUTCHours() >= 12;
        }
      });
    });
    const minutesOptions = computed(() => {
      return Array.from({
        length: 60
      }, (_value, index) => {
        var _a, _b, _c, _d;
        const value = index;
        return new Date(Date.UTC(((_a = model.value) !== null && _a !== void 0 ? _a : props.initialValue).getUTCFullYear(), ((_b = model.value) !== null && _b !== void 0 ? _b : props.initialValue).getUTCMonth(), ((_c = model.value) !== null && _c !== void 0 ? _c : props.initialValue).getUTCDate(), ((_d = model.value) !== null && _d !== void 0 ? _d : props.initialValue).getUTCHours(), value));
      });
    });
    // Methods
    function formatHours(value) {
      return value.toLocaleString(props.locale, {
        hour: 'numeric',
        hourCycle: typeof props.format !== 'function' && props.format !== TimeFormat.Auto ? props.format : undefined,
        timeZone: 'UTC'
      }).replace(/\D/g, '');
    }
    function formatMinutes(value) {
      return String(value.getUTCMinutes()).padStart(2, '0');
    }
    return {
      root,
      rootStyles,
      buttonGroupStyles,
      buttonGroupItemStyles,
      model,
      dayPeriod,
      proxyTimeFormat,
      hoursOptions,
      minutesOptions,
      formatHours,
      formatMinutes
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrButton = resolveComponent("OrButton");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles)
  }, [createElementVNode("div", {
    class: normalizeClass(_ctx.buttonGroupStyles)
  }, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.hoursOptions, value => {
    return openBlock(), createBlock(_component_OrButton, {
      key: Number(value),
      class: normalizeClass(_ctx.buttonGroupItemStyles),
      variant: Number(value) === Number(_ctx.model) ? 'contained' : 'text',
      color: Number(value) === Number(_ctx.model) ? 'primary' : 'inherit',
      disabled: _ctx.hoursFilter && !_ctx.hoursFilter(value),
      onClick: withModifiers($event => _ctx.model = value, ["stop"])
    }, {
      default: withCtx(() => [createTextVNode(toDisplayString(_ctx.formatHours(value)), 1 /* TEXT */)]),
      _: 2 /* DYNAMIC */
    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "variant", "color", "disabled", "onClick"]);
  }), 128 /* KEYED_FRAGMENT */))], 2 /* CLASS */), createTextVNode(" : "), createElementVNode("div", {
    class: normalizeClass(_ctx.buttonGroupStyles)
  }, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.minutesOptions, value => {
    return openBlock(), createBlock(_component_OrButton, {
      key: Number(value),
      class: normalizeClass(_ctx.buttonGroupItemStyles),
      variant: Number(value) === Number(_ctx.model) ? 'contained' : 'text',
      color: Number(value) === Number(_ctx.model) ? 'primary' : 'inherit',
      disabled: _ctx.minutesFilter && !_ctx.minutesFilter(value),
      onClick: withModifiers($event => _ctx.model = value, ["stop"])
    }, {
      default: withCtx(() => [createTextVNode(toDisplayString(_ctx.formatMinutes(value)), 1 /* TEXT */)]),
      _: 2 /* DYNAMIC */
    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "variant", "color", "disabled", "onClick"]);
  }), 128 /* KEYED_FRAGMENT */))], 2 /* CLASS */), _ctx.proxyTimeFormat === 'h12' ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: normalizeClass(_ctx.buttonGroupStyles)
  }, [createVNode(_component_OrButton, {
    class: normalizeClass(_ctx.buttonGroupItemStyles),
    variant: _ctx.dayPeriod === 'am' ? 'contained' : 'text',
    color: _ctx.dayPeriod === 'am' ? 'primary' : 'inherit',
    onClick: _cache[0] || (_cache[0] = withModifiers($event => _ctx.dayPeriod = 'am', ["stop"]))
  }, {
    default: withCtx(() => [createTextVNode(" AM ")]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class", "variant", "color"]), createVNode(_component_OrButton, {
    class: normalizeClass(_ctx.buttonGroupItemStyles),
    variant: _ctx.dayPeriod === 'pm' ? 'contained' : 'text',
    color: _ctx.dayPeriod === 'pm' ? 'primary' : 'inherit',
    onClick: _cache[1] || (_cache[1] = withModifiers($event => _ctx.dayPeriod = 'pm', ["stop"]))
  }, {
    default: withCtx(() => [createTextVNode(" PM ")]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class", "variant", "color"])], 2 /* CLASS */)) : createCommentVNode("v-if", true)], 2 /* CLASS */);
}

script.render = render;
script.__file = "src/components/or-date-time-picker-v3/partials/or-date-time-picker-time-select/OrDateTimePickerTimeSelect.vue";

export { script$6 as a, script$5 as b, script$4 as c, script$3 as d, script$2 as e, script$1 as f, script as g, script$7 as s };
